<div class="confirm-modal ig-modal edit-place-category-modal">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <h3 class="title">EDIT PLACE CATEGORIES</h3>

<!--    <div class="text-left m-b-3"><b>Selected categories: </b><span>{{place.categoryText}}</span></div>-->
    <div class="text-left m-b-3">
        <b>Selected categories: </b>
        <mat-chip-list #chipList aria-label="Type selection">
            <mat-chip *ngFor="let category of place.categoryList" [selectable]="true"
                      [removable]="true" (removed)="remove(category)">
                {{toReadable(category)}}
                <mat-icon matChipRemove matTooltip="remove">cancel</mat-icon>
            </mat-chip>
        </mat-chip-list>
    </div>

    <div class="edit-wrap">
        <ng-container *ngIf="!isUseDefault">
            <div *ngFor="let item of clientPlaceCategories" class="m-b-3">
                <ig-place-category-selector [item]="item" [place]="place" [blockGooglePlaceCategories]="blockGooglePlaceCategories"></ig-place-category-selector>
            </div>
        </ng-container>

        <ng-container *ngIf="isUseDefault">
            <div *ngFor="let category of mergedDefaultCategories" class="m-b-3">
                <div>{{category.keys[0]}}</div>
                <hr>
                <span *ngFor="let sub of category.values">
                    <mat-checkbox [checked]="isSelected(sub)"
                                  (change)="normalCategorySelected(sub)"
                                  [name]="sub"
                                  style="margin-right: 26px">{{toReadable(sub)}}
                    </mat-checkbox>
                    <mat-icon *ngIf="blockGooglePlaceCategories.indexOf(sub)>=0"
                              style="color:lightgray;margin: 0 24px 0 -24px"
                              matTooltip="This category is blocked by admin">info
                    </mat-icon>
                </span>
            </div>
        </ng-container>
    </div>

    <div class="action-btns">
        <ig-button class="btn-primary" #confirmButton color="primary" size="md"
                   [isAsync]="true"
                   (trigger)="confirm($event)">
            Save
        </ig-button>
        <div class="cancel-btn" *ngIf="!confirmButton.isLoading" (click)="close()">
            Cancel
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/edit.place.category.modal/edit.place.category.modal.component.html